import { render, staticRenderFns } from "./pos-checkout-order-items-list.vue?vue&type=template&id=1ddf704a&scoped=true&"
import script from "./pos-checkout-order-items-list.ts?vue&type=script&lang=ts&"
export * from "./pos-checkout-order-items-list.ts?vue&type=script&lang=ts&"
import style0 from "./pos-checkout-order-items-list.scss?vue&type=style&index=0&id=1ddf704a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf704a",
  null
  
)

export default component.exports